import React from "react";
import { FormFieldProps } from "~/components/forms/FormFieldProps";
import { SimplePicker } from "~/visuals/organisms/SimplePicker";
import { Suggestion } from "~/components/ultra-filter/types";

export const projectStatusOptions = [
  { text: "Active", value: "Active" },
  { text: "Closed", value: "Closed" },
] as Suggestion[];

export const ProjectStatusPicker: React.FC<FormFieldProps> = (props) => (
  <SimplePicker {...{ ...props, options: projectStatusOptions }} />
);
